import { Navigate, Route, Routes } from 'react-router';
import Config, { type MultiLang } from '../config';
import Credits from '../credits/Credits';
import CreditsXoopsPathRedirect from '../credits/CreditsXoopsPathRedirect';
import Database from '../database/Database';
import DatabaseXoopsPathRedirect from '../database/DatabaseXoopsPathRedirect';
import Pico from '../pico/Pico';
import PicoXoopsPathRedirect from '../pico/PicoXoopsPathRedirect';
import XoopsPathRedirect from './XoopsPathRedirect';

interface Props {
    lang: MultiLang;
}

const MainContent = (props: Props) => {
    const { lang } = props;
    return (
        <div className="mainContent">
            <Routes>
                <Route path="/database/list/6940" element={<Navigate to="/primface" replace />} />
                <Route path="/database/*" element={<Database lang={lang} />} />
                <Route path="/credits/*" element={<Credits lang={lang} />} />
                {Config.PICO_MODULES.map((name) => (
                    <Route key={name} path={`/${name}/*`} element={<Pico lang={lang} name={name} />} />
                ))}
                <Route path="/modules/xoonips/*" element={<DatabaseXoopsPathRedirect lang={lang} />} />
                <Route path="/modules/credits/*" element={<CreditsXoopsPathRedirect lang={lang} />} />
                {Config.PICO_MODULES.map((name) => (
                    <Route
                        key={name}
                        path={`/modules/${name}/*`}
                        element={<PicoXoopsPathRedirect lang={lang} name={name} />}
                    />
                ))}
                <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
            </Routes>
        </div>
    );
};

export default MainContent;
